import { areaArticuloRoutesMap } from './modules/areaArticulo/areaArticuloRoutes'
import { areasRoutesMap } from './modules/areas/areasRoutes'
import { cajasRoutesMap } from './modules/cajas/cajasRoutes'
import { clientsRoutesMap } from './modules/clients/clientsRoutes'
import { cocinaRoutesMap } from './modules/cocina/cocinaRoutes'
import { entradaRoutesMap } from './modules/entrada/entradaRoutes.tsx'
import { homeRoutesMap } from './modules/home/HomeRoutes'
import { impresorasRoutesMap } from './modules/impresoras/impresorasRoutes'
import { ncdGestionRoutesMap } from './modules/notaCreditoDebito/notaCreditoDebitoRoutes'
import { reporteRoutesMap } from './modules/reporte/reporteRoutes'
import { restauranteRoutesMap } from './modules/restaurante/restauranteRoutes'

export interface NavigationProps {
  name: string
  path?: string
  icon?: any
  iconText?: string
  label?: string
  type?: string
  badge?: { value: string; color: string }
  children?: Array<{
    name: string
    icon?: string
    iconText: string
    path: string
  }>
}

export const navigations: NavigationProps[] = [
  {
    name: homeRoutesMap.home.name,
    icon: 'dashboard',
    path: homeRoutesMap.home.path,
  },
  {
    name: 'Ventas y Pedidos',
    icon: 'shopping_cart',
    children: [
      {
        name: restauranteRoutesMap.registro.name,
        iconText: 'PR',
        path: restauranteRoutesMap.registro.path,
      },
      {
        name: restauranteRoutesMap.gestion.name,
        iconText: 'PG',
        path: restauranteRoutesMap.gestion.path,
      },
      {
        name: restauranteRoutesMap.facturas.name,
        iconText: 'FA',
        path: restauranteRoutesMap.facturas.path,
      },
    ],
  },
  {
    name: cocinaRoutesMap.pantalla.name,
    icon: 'flatware',
    path: cocinaRoutesMap.pantalla.path,
  },
  {
    name: 'Notas de Credito Debito',
    icon: 'description',
    children: [
      {
        name: ncdGestionRoutesMap.ncdGestion.name,
        iconText: 'NGD',
        path: ncdGestionRoutesMap.ncdGestion.path,
      },
    ],
  },
  {
    name: 'Cajas',
    icon: 'point_of_sale',
    children: [
      {
        name: cajasRoutesMap.gestion.name,
        iconText: 'GC',
        path: cajasRoutesMap.gestion.path,
      },
    ],
  },
  {
    name: 'Entradas',
    icon: 'add_business',
    children: [
      {
        name: entradaRoutesMap.gestion.name,
        iconText: 'ENT',
        path: entradaRoutesMap.gestion.path,
      },
    ],
  },
  {
    name: 'Clientes',
    icon: 'person',
    children: [
      {
        name: clientsRoutesMap.clients.name,
        icon: '',
        iconText: 'CL',
        path: clientsRoutesMap.clients.path,
      },
    ],
  },
  {
    name: 'Reportes',
    icon: 'bar_chart',
    children: [
      {
        name: 'Artículos por PV',
        iconText: 'APV',
        path: reporteRoutesMap.articuloPorPuntoVenta.path,
      },
      {
        name: 'Artículos por Sucursal',
        iconText: 'APS',
        path: reporteRoutesMap.articuloPorComercio.path,
      },
      {
        name: 'Pedidos Observados',
        iconText: 'PO',
        path: reporteRoutesMap.pedidosSospechosos.path,
      },
    ],
  },
  {
    name: 'Local',
    icon: 'restaurant',
    children: [
      {
        name: impresorasRoutesMap.gestion.name,
        iconText: 'IMP',
        path: impresorasRoutesMap.gestion.path,
      },
      {
        name: impresorasRoutesMap.documentos.name,
        iconText: 'IPD',
        path: impresorasRoutesMap.documentos.path,
      },
      {
        name: areasRoutesMap.gestion.name,
        iconText: 'ARE',
        path: areasRoutesMap.gestion.path,
      },
      {
        name: areaArticuloRoutesMap.gestion.name,
        iconText: 'APA',
        path: areaArticuloRoutesMap.gestion.path,
      },
      // {
      //   name: impresorasRoutesMap.articulos.name,
      //   iconText: 'IPA',
      //   path: impresorasRoutesMap.articulos.path,
      // },
    ],
  },
]

/*
// Ejemplo de estructura con Hijos
  {
    name: 'Configuración',
    icon: 'settings',
    children: [
      {
        name: configuracionRoutesMap.parametrosSistema.name,
        iconText: 'PSI',
        path: configuracionRoutesMap.parametrosSistema.path,
      },
    ],
  }
*/
